<div class="media-page page-shell">
  <mat-toolbar class="header">
    <span>{{ "menu.media" | translate }}</span>
    <div class="header-buttons">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="showAddForm()"
        [disabled]="images == null"
      >
        <mat-icon>add</mat-icon>
        {{ "media.images.add" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="media-content">
    <div class="empty-state" *ngIf="images != null && images.length === 0">
      <mat-icon class="empty-state__icon">image</mat-icon>
      <p>{{ "media.images.empty" | translate }}</p>
    </div>

    <div class="media-grid" *ngIf="images != null && images.length > 0">
      <app-image *ngFor="let image of images" [image]="image"></app-image>
    </div>

    <div class="dbc1-loading dbc1-loading--overlay" *ngIf="images == null">
      <app-loading></app-loading>
    </div>
  </div>
</div>
